<template>
  <v-ons-page class="l-content">
    <custom-toolbar backLabel="Retour">{{ $t("Parrainage") }}</custom-toolbar>

    <div class="container">
      <div v-html="$t('SPONSORSHIP_TEXT')"></div>
      <v-ons-button @click="sponsor">{{ $t("Formulaire") }}</v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
  import SponsorshipForm from './SponsorshipForm.vue';

  export default {
    data () {
      return {
        user: loggedIn
      };
    },
    methods: {
      sponsor() {
        this.$store.commit('navigator/push', SponsorshipForm);
      }
    },
  };
</script>


// WEBPACK FOOTER //
// Sponsorship.vue?3c430de0